// Autopilot: auto-accept the recommended default on LOW-stakes nodes (with a
// visible countdown), pausing on anything consequential. Chains through
// prefetched nodes, so it visibly designs at machine speed until judgment is
// needed.

import { pick } from "../core/navigation";
import { state } from "../core/state";
import { toast } from "./toast";

let autopilot = false;
let autoTimer: ReturnType<typeof setTimeout> | null = null;
const AUTO_DWELL = 1400;   // ms to read the decision before it self-accepts

export function isAutopilotOn(): boolean { return autopilot; }

export function toggleAutopilot(): void {
  if (autopilot) return stopAutopilot("autopilot off");
  autopilot = true;
  document.body.classList.add("autopilot");
  toast("autopilot on — accepting low-stakes defaults, pausing on anything consequential");
  autopilotTick();
}

export function stopAutopilot(msg?: string): void {
  autopilot = false;
  if (autoTimer) clearTimeout(autoTimer);
  document.body.classList.remove("autopilot");
  document.querySelector(".option.auto-counting")?.classList.remove("auto-counting");
  if (msg) toast(msg);
}

function autopilotTick(): void {
  if (!autopilot) return;
  const n = state.nodes.get(state.currentId!);
  if (!n || !n.options.length) return stopAutopilot();
  if (n.depth === 0 || n.stakes !== "low") {
    return stopAutopilot(`autopilot paused — ${n.depth === 0 ? "pick a branch" : n.stakes + "-stakes decision needs you"}`);
  }
  const rec = n.recommend ?? 0;
  const row = document.querySelector(`.option[data-i="${rec}"]`);
  row?.classList.add("auto-counting");   // CSS countdown fill over AUTO_DWELL
  autoTimer = setTimeout(async () => {
    if (!autopilot || state.currentId !== n.id) return;
    await pick(rec);
    autopilotTick();
  }, AUTO_DWELL);
}
